import React, { useEffect, useState } from "react";
import "./FarmForm.scss";
import { InfoCircleOutlined, SyncOutlined } from "@ant-design/icons";
import { Checkbox, Input, Button, Image, Radio } from "antd";
import Helpers from "@utils/Helpers";

interface IFarmForm {
  formSignUp: any;
  setCurrentStep: (step: number) => void;
  handleSetFormSignUp: any;
  signUp: () => void;
  googleId: string | null;
  setFormSignUp: (form: any) => void;
}

const FarmForm: React.FC<IFarmForm> = ({
  formSignUp,
  setCurrentStep,
  handleSetFormSignUp,
  signUp,
  googleId,
  setFormSignUp,
}) => {
  const [displayNameList, setDisplayNameList] = useState<string[]>([]);
  const [selectedLocation, setSelectedLocation] = useState<any>({});
  const [isCreateProfileName, setIsCreateProfileName] = useState(false);

  useEffect(() => {
    const list = Helpers.generateUsername(
      formSignUp.first_name,
      formSignUp.city
    );
    setDisplayNameList(list);
    handleSetFormSignUp("display_name", list[0]);
  }, []);

  const handleSelectUserType = (e: any) => {
    const value = e.target.value;
    const check = e.target.checked;

    var userTypeTmp = [...formSignUp.type_ids];
    if (check) {
      userTypeTmp.push(value);
    } else {
      userTypeTmp = userTypeTmp.filter((item) => item !== value);
    }

    handleSetFormSignUp("type_ids", userTypeTmp);
  };

  const handleChangeDisplayName = () => {
    const index = displayNameList.findIndex(
      (userName: string) => userName === formSignUp.display_name
    );
    const randomName = displayNameList[index === 4 ? 0 : index + 1];
    handleSetFormSignUp("display_name", randomName);
  };

  useEffect(() => {
    if (Object.keys(selectedLocation).length > 0) {
      setFormSignUp({
        ...formSignUp,
        farm_info: {
          ...formSignUp.farm_info,
          postal_code: selectedLocation.postCode,
          street: selectedLocation.address.road
            ? selectedLocation.address.road
            : selectedLocation.display_name,
          city: selectedLocation.address.city
            ? selectedLocation.address.city
            : selectedLocation.address.town
            ? selectedLocation.address.town
            : selectedLocation.address.county
            ? selectedLocation.address.county
            : selectedLocation.address.village,
          province: selectedLocation.address.province
            ? selectedLocation.address.province
            : selectedLocation.address.state
            ? selectedLocation.address.state
            : selectedLocation.address.city,
          lat: selectedLocation.lat,
          lon: selectedLocation.lon,
        },
      });
    }
  }, [selectedLocation]);

  return (
    <div className="FarmForm">
      <div className="forn-group mb-3">
        <div className="title">
          Profile Name <span className="text-danger">*</span>
        </div>
        <Radio.Group
          className="radio-group"
          onChange={(e) => setIsCreateProfileName(e.target.value)}
          value={isCreateProfileName}
          options={[
            {
              value: false,
              label: "Auto generate",
            },
            {
              value: true,
              label: "Create your own user name",
            },
          ]}
        />
        <Input
          className="ant-form"
          variant="filled"
          size="large"
          disabled={!isCreateProfileName}
          maxLength={45}
          showCount
          value={formSignUp.display_name}
          onChange={(e) => handleSetFormSignUp("display_name", e.target.value)}
          suffix={
            <SyncOutlined
              className="sync-btn"
              onClick={handleChangeDisplayName}
            />
          }
        />
      </div>
      <div className="form-group mb-3">
        <div className="title mb-1">
          Select Your Role
        </div>
        <Checkbox
          onChange={handleSelectUserType}
          value={1}
          checked={formSignUp.type_ids.includes(1)}
          className="me-4"
        >
          Consumer
        </Checkbox>
        <Checkbox
          onChange={handleSelectUserType}
          value={2}
          checked={formSignUp.type_ids.includes(2)}
        >
          Producer
        </Checkbox>
      </div>
      <div className="form-group">
        <Button className="create-btn" onClick={signUp}>
          Create Account
        </Button>
        <Button
          className="prev-btn"
          onClick={() => {
            if (googleId !== undefined) {
              setCurrentStep(1);
            } else {
              setCurrentStep(2);
            }
          }}
        >
          Back
        </Button>
      </div>
    </div>
  );
};

export default FarmForm;
